import { Component, OnInit } from '@angular/core';
import { ROUTE_TRANSITION } from 'app/app.animation';

@Component({
  selector: 'vr-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss'],
  animations: [...ROUTE_TRANSITION],
  host: { '[@routeTransition]': '' }
})
export class IndexComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
